// extracted by mini-css-extract-plugin
module.exports = {"iconLeft":"styles_iconLeft__1N62F","pdtImage":"styles_pdtImage__2Sj3s","icon":"styles_icon__3Y7fX"};